import httpClient from "../utils/http";
import { ENDPOINTS } from "../utils/endpoints";
import type { IResponse, INotificationData } from "../interfaces";

/**
 * Get paginated notifications for admin
 * @param params - Pagination parameters
 * @returns Promise with grouped notifications and unread count
 */
export const getNotifications = async (params?: {
  page?: number;
  limit?: number;
}): Promise<IResponse<INotificationData>> => {
  const queryParams: Record<string, number> = {};
  if (params?.page) queryParams.page = params.page;
  if (params?.limit) queryParams.limit = params.limit;

  const response = await httpClient.get<IResponse<INotificationData>>(
    ENDPOINTS.GET_NOTIFICATIONS,
    { params: queryParams }
  );
  return response.data;
};

/**
 * Mark all notifications as seen
 * @returns Promise with response
 */
export const markAllNotificationsSeen = async (): Promise<IResponse> => {
  const response = await httpClient.put<IResponse>(
    ENDPOINTS.MARK_NOTIFICATIONS_SEEN
  );
  return response.data;
};

/**
 * Clear all notifications
 * @returns Promise with response
 */
export const clearAllNotifications = async (): Promise<IResponse> => {
  const response = await httpClient.put<IResponse>(
    ENDPOINTS.CLEAR_NOTIFICATIONS
  );
  return response.data;
};
